import { useContext } from 'react';
import { object, func, bool } from 'prop-types';
import { NavigationContext } from '../../context/NavigationContext';
import { NavigationButtons } from 'shared/buttons';

const FinalFormNavigation = ({
  errors,
  handleSubmit,
  loading,
}) => {
  const {
    currentStepIndex,
    activeFlow,
    updateStepIndex,
    recalculatingFromIndex,
    onResultPage,
    onFinalResultPage,
  } = useContext(NavigationContext);

  const isOnFirstStep = currentStepIndex === 0;
  const isOnLastStep = currentStepIndex === activeFlow.length - 2;
  const onBaseFlowResultPage = onResultPage && !onFinalResultPage

  let nextLabelText = 'Volgende stap';
  if (isOnLastStep) nextLabelText = 'Berekenen';
  if (onBaseFlowResultPage) nextLabelText = 'Nauwkeurige berekening';
  if (recalculatingFromIndex) nextLabelText = 'Herberekenen';

  return (
    <NavigationButtons
      showNextButton={!onFinalResultPage}
      onClickNext={() => {
        if (!Object.keys(errors ?? []).length) {
          if (onResultPage && !recalculatingFromIndex) {
            updateStepIndex(currentStepIndex + 1);
          } else {
            handleSubmit();
          }
        }
      }}
      nextLabel={nextLabelText}
      showPreviousButton={!isOnFirstStep && !recalculatingFromIndex}
      onClickPrevious={() => {
        if (!Object.keys(errors ?? []).length) {
          updateStepIndex(currentStepIndex - 1);
        }
      }}
      previousLabel={onResultPage ? 'Gegevens aanpassen' : 'Terug'}
      loading={loading}
    />
  )
};

FinalFormNavigation.propTypes = {
  errors: object.isRequired,
  handleSubmit: func.isRequired,
  loading: bool.isRequired,
};

export default FinalFormNavigation;
